import(/* webpackMode: "eager" */ "/home/runner/work/UllrWeb/UllrWeb/app/global-error.tsx");
